import { axiosInstance } from "../../../util/axios";
import Constants from "../../../Constants";

export const getAssets = () => {
  const baseUrl = "https://www.apidigitalappsiafg.net/afg-ikea-digital/";
  return axiosInstance.get(
    `${baseUrl}${Constants?.["QA"]?.getKioskHomeAssets}`,
    {
      headers: {
        Authorization: "bearer PlsMAswessAEGTNDecRayIivzirziYppENaiW",
      },
    }
  );
};
